import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function generateCostCode(price: number, alphabet: string): string {
  const cleanAlphabet = (alphabet || "").trim();
  const isInt = Math.floor(price) === price;
  const inputStr = isInt ? price.toString() : price.toFixed(2);

  if (cleanAlphabet.length < 10) {
    return inputStr;
  }

  const cipher = cleanAlphabet.toUpperCase().padEnd(11, "X");
  const digitToLetter: Record<string, string> = {};
  for (let i = 0; i < 10; i++) {
    digitToLetter[i.toString()] = cipher[i] || "X";
  }
  const repeatChar = cipher[10] || "X";
  digitToLetter["."] = ".";

  let result = "";
  let lastChar: string | null = null;
  for (let i = 0; i < inputStr.length; i++) {
    const char = inputStr[i];
    if (char === lastChar && char !== ".") {
      result += repeatChar;
    } else {
      result += digitToLetter[char] ?? char;
    }
    lastChar = char;
  }
  return result;
}
